import React, { useEffect, useMemo, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/dist/styles.css";
import sasaMain from "../../static/illustrator.png";
import sasaSub1 from "../../static/gallery/operator-n.png";
import sasaSub2 from "../../static/gallery/readbook_color.png";
import sasaSub3 from "../../static/gallery/word2vec2.png";
import momoMain from "../../static/gallery/challenge-book3-ext.png";
import momoSub1 from "../../static/gallery/operator-e1.png";
import momoSub2 from "../../static/gallery/search_momo.jpg";
import dummyPortrait from "../../static/logo.svg";
import { SlideInLeft } from "./AnimationTrigger";

const characterRoster = [
  {
    id: "sasa",
    name: "紗々（ささ）",
    order: "長女",
    accent: "sasa",
    portrait: sasaMain,
    gallery: [sasaMain, sasaSub1, sasaSub2, sasaSub3],
    profileRows: [
      { label: "年齢／学年", value: "18歳／高校3年生" },
      { label: "身長／体型", value: "158cm／スレンダーだけどお姉さんらしさもある" },
      { label: "血液型", value: "O型" },
      { label: "誕生日", value: "4月8日" },
      { label: "テーマカラー", value: "茶色" },
      { label: "チャームポイント", value: "真っ赤なリボン / パレット型イヤリング / インクボトル型ネックレス / 茶色のふとももベルト" },
      { label: "将来の夢", value: "イラストレーター" },
    ],
    catchphrase: "“いつもみんなの太陽でいたい、おっちょこちょいなお姉さん！”",
  },
  {
    id: "shishi",
    name: "詩紫（しし）",
    order: "次女",
    accent: "shishi",
    portrait: dummyPortrait,
    gallery: [dummyPortrait],
    profileRows: [
      { label: "年齢／学年", value: "17歳／高校2年生" },
      { label: "身長／体型", value: "150cm／スレンダーで細身" },
      { label: "血液型", value: "A型" },
      { label: "誕生日", value: "2月3日" },
      { label: "テーマカラー", value: "ロイヤルブルー、ネイビー" },
      { label: "チャームポイント", value: "雫型ハイライト / さしみもちチャーム付きヘアピン / 本型チャームネックレス / 青いペンホルダー付きふとももガーター" },
      { label: "将来の夢", value: "弁護士" },
    ],
    catchphrase: "冷静沈着、頭脳明晰、超真面目。融通が利かないのが玉にキズ",
  },
  {
    id: "mimi",
    name: "未海（みみ）",
    order: "三女",
    accent: "mimi",
    portrait: dummyPortrait,
    gallery: [dummyPortrait],
    profileRows: [
      { label: "年齢／学年", value: "16歳／高校1年生" },
      { label: "身長／体型", value: "160cm／スポーツマンらしくスタイル良い" },
      { label: "血液型", value: "A型" },
      { label: "誕生日", value: "8月11日" },
      { label: "テーマカラー", value: "赤" },
      { label: "チャームポイント", value: "泣き母黒 / 紅白リストバンド / テニスラケット型チャームネックレス / 赤いふとももリボン" },
      { label: "将来の夢", value: "スポーツインストラクター" },
    ],
    catchphrase: "快活でよく笑う、明るいムードメーカー。活発なスポーツ少女で、テニスが得意",
  },
  {
    id: "momo",
    name: "桃（もも）",
    order: "四女",
    accent: "momo",
    portrait: momoMain,
    gallery: [momoMain, momoSub1, momoSub2],
    profileRows: [
      { label: "年齢／学年", value: "14歳／中学2年生" },
      { label: "身長／体型", value: "162cm／スタイル抜群" },
      { label: "血液型", value: "A型" },
      { label: "誕生日", value: "3月3日" },
      { label: "テーマカラー", value: "ピンク" },
      { label: "チャームポイント", value: "ハート型アホ毛 / 頬の星形マーク / 月型ネックレス / ピンクのふともも2重ベルト" },
      { label: "将来の夢", value: "ファッションモデル" },
    ],
    catchphrase: "さしみもちファミリーのおしゃれ番長、桃ですっ☆",
  },
  {
    id: "chichi",
    name: "千智（ちち）",
    order: "5女・末っ子",
    accent: "chichi",
    portrait: dummyPortrait,
    gallery: [dummyPortrait],
    profileRows: [
      { label: "年齢／学年", value: "11歳／小学5年生" },
      { label: "身長／体型", value: "140cm／まだまだこれから！" },
      { label: "血液型", value: "O型" },
      { label: "誕生日", value: "5月4日" },
      { label: "テーマカラー", value: "ライムグリーン、若葉色" },
      { label: "チャームポイント", value: "双葉模様のハイライト / リボン付きベレー帽 / 懐中時計チャームネックレス / 緑の蔦状ふとももリボン" },
      { label: "将来の夢", value: "ケーキ屋さん" },
    ],
    catchphrase: "好奇心旺盛で、お姉ちゃんたちの真似をしたがる背伸び盛り。「子供扱いしないで！」が口癖だが、結局最後はお姉ちゃんたちに甘えてしまう、愛されキャラ",
  },
];

function IllustratorGallery() {
  const [activeCharacterId, setActiveCharacterId] = useState(characterRoster[0].id);
  const [lightboxIndex, setLightboxIndex] = useState(-1);

  useEffect(() => {
    const preventLightboxImageContextMenu = (event) => {
      if (
        lightboxIndex >= 0 &&
        event.target instanceof HTMLImageElement &&
        event.target.closest(".yarl__root")
      ) {
        event.preventDefault();
      }
    };

    document.addEventListener("contextmenu", preventLightboxImageContextMenu, true);
    return () => document.removeEventListener("contextmenu", preventLightboxImageContextMenu, true);
  }, [lightboxIndex]);

  const preventImageContextMenu = (event) => {
    if (event.target instanceof HTMLImageElement) {
      event.preventDefault();
    }
  };
  const preventImageDrag = (event) => {
    if (event.target instanceof HTMLImageElement) {
      event.preventDefault();
    }
  };

  const activeCharacter = useMemo(
    () => characterRoster.find((character) => character.id === activeCharacterId) ?? characterRoster[0],
    [activeCharacterId]
  );

  const slides = useMemo(
    () =>
      activeCharacter.gallery.map((src, index) => ({
        src,
        alt: `${activeCharacter.name} ギャラリー ${index + 1}`,
      })),
    [activeCharacter]
  );

  return (
    <section
      className="illustrator-gallery"
      aria-label="うちの子ギャラリー"
      onContextMenu={preventImageContextMenu}
      onDragStart={preventImageDrag}
    >
      <SlideInLeft
        component={
          <header className="illustrator-gallery__hero">
            <p className="illustrator-gallery__eyebrow">CHARACTER GALLERY</p>
            <h3>うちの子5人ギャラリー</h3>
            <p className="illustrator-gallery__lead">サムネイルを選ぶと、各キャラのプロフィールとギャラリーを切り替えられます。</p>
          </header>
        }
      />

      <div className="illustrator-gallery__selector" role="tablist" aria-label="キャラクター選択">
        {characterRoster.map((character) => {
          const isActive = character.id === activeCharacter.id;
          return (
            <button
              key={character.id}
              className={`character-thumb character-thumb--${character.accent} ${isActive ? "is-active" : ""}`}
              onClick={() => setActiveCharacterId(character.id)}
              role="tab"
              aria-selected={isActive}
              aria-label={`${character.name} ${character.order}`}
            >
              <img src={character.portrait} alt={character.name} draggable="false" />
              <span>{character.name}</span>
            </button>
          );
        })}
      </div>

      <article className={`character-panel character-panel--${activeCharacter.accent}`}>
        <div className="character-panel__main-image" onClick={() => setLightboxIndex(0)}>
          <img src={activeCharacter.portrait} alt={activeCharacter.name} draggable="false" />
        </div>
        <div className="character-panel__profile">
          <h4>{activeCharacter.name}</h4>
          <p className="character-panel__order">{activeCharacter.order}</p>

          <dl className="character-profile-list">
            {activeCharacter.profileRows.map((row) => (
              <React.Fragment key={row.label}>
                <dt>{row.label}</dt>
                <dd>{row.value}</dd>
              </React.Fragment>
            ))}
          </dl>

          <p className="character-panel__catchphrase">{activeCharacter.catchphrase}</p>

          <div className="character-panel__sub-gallery">
            {activeCharacter.gallery.map((src, index) => (
              <button key={`${activeCharacter.id}-${index}`} onClick={() => setLightboxIndex(index)}>
                <img src={src} alt={`${activeCharacter.name} サブ画像 ${index + 1}`} />
              </button>
            ))}
          </div>
        </div>
      </article>

      <Lightbox
        open={lightboxIndex >= 0}
        close={() => setLightboxIndex(-1)}
        index={lightboxIndex}
        slides={slides}
        controller={{ closeOnBackdropClick: true }}
      />
    </section>
  );
}

export default IllustratorGallery;
